// Corrige la hauteur de l'appli sur mobile face aux limites de `100dvh` sur certains WebKit
// (Safari iOS peut le calculer trop grand — notamment quand la page est ouverte depuis une autre
// appli, ex. l'Appareil photo après un scan de QR code — et ne le recalcule pas ensuite, laissant
// une zone vide en bas, hors de l'écran réellement visible). On fixe donc la hauteur exacte en
// pixels via une variable CSS, tenue à jour à chaque changement de la fenêtre visible.
//
// window.visualViewport.height est préféré à window.innerHeight : sur iOS, il reflète la zone
// vraiment visible (barre d'outils Safari en cours d'animation, clavier virtuel ouvert...),
// alors qu'innerHeight ne bouge pas toujours immédiatement dans ces cas.
export function watchViewportHeight() {
  const root = document.documentElement;

  function setHeight() {
    const height = window.visualViewport?.height ?? window.innerHeight;
    root.style.setProperty('--app-100vh', `${height}px`);
  }

  setHeight();
  // La toute première mesure peut être transitoire (ex. sur iOS, juste après une ouverture
  // depuis une autre appli comme l'Appareil photo, avant que la barre d'outils de Safari n'ait
  // fini de se stabiliser) sans qu'aucun des événements ci-dessous ne se déclenche ensuite pour
  // la corriger : on la revérifie donc à quelques échéances courtes après le chargement.
  const settleTimers = [50, 250, 800].map((delay) => setTimeout(setHeight, delay));

  window.addEventListener('resize', setHeight);
  window.addEventListener('orientationchange', setHeight);
  window.addEventListener('pageshow', setHeight); // retour depuis le cache arrière (bfcache)
  document.addEventListener('visibilitychange', setHeight);
  window.visualViewport?.addEventListener('resize', setHeight);
  // Sur iOS, la visualViewport se décale (sans changer de taille) quand la barre d'adresse
  // se réduit/étend : un simple `resize` ne suffit pas toujours à capter le nouvel état stable.
  window.visualViewport?.addEventListener('scroll', setHeight);

  return () => {
    settleTimers.forEach(clearTimeout);
    window.removeEventListener('resize', setHeight);
    window.removeEventListener('orientationchange', setHeight);
    window.removeEventListener('pageshow', setHeight);
    document.removeEventListener('visibilitychange', setHeight);
    window.visualViewport?.removeEventListener('resize', setHeight);
    window.visualViewport?.removeEventListener('scroll', setHeight);
  };
}
